module.exports = __webpack_public_path__ + "static/media/logo.ace038ae.png";